import styled from "styled-components";

export const FooterStyle = styled.section`
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #019acb;
    width: 100%;
    color: white;
    gap: 60px;
    text-align: center;

    a {
        text-decoration: none;
        color: white;
    }
`